var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header3'),_vm._v(" "),_c('project-info',{attrs:{"projectId":parseInt(_vm.$route.query.projectId),"trainingId":parseInt(_vm.$route.query.trainingId)}}),_vm._v(" "),_c('footer1')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac5299a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/usercenter/ProjectDetail.vue
// module id = null
// module chunks = 